import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import FieldEditor from "editor/FieldEditor";


class AddContentInputModal extends Modal {

    constructor(settings = {}) {
        super(settings);


        let $content = eotwJSXFactory('form', {class: "admin-form"}, [
            eotwJSXFactory('h1', null, ["Add a field"]),

            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "content-field-name"}, ["Field Name"]),
                eotwJSXFactory('input', {type: "text", class: "admin-form__input", name: "name", id: "content-field-name"}),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),

            eotwJSXFactory('div', {class: "admin-form__row"}, [
                eotwJSXFactory('label', {class: "admin-form__label", for: "content-field-type"}, ["Field Type"]),
                eotwJSXFactory('div', {class: "admin-form__input-wrap admin-form__input-wrap--half"}, [
                    eotwJSXFactory('select', {class: "admin-form__select", name: "type", id: "content-field-type"}, [
                        Object.keys(FieldEditor.editors).filter((name) => /^content\/admin\/[^\/]+$/.test(name)).map((name) => (
                            eotwJSXFactory('option', {value: name}, [FieldEditor.editors[name].get_name()])
                        ))
                    ]),
                    eotwJSXFactory('span', {class: "admin-form__icon admin-form__icon--select"}).html('<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.CONFIG.adminBuildUrl + 'base/icons.svg#select-arrow"></use></svg>')
                ]),
                eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
            ]),

            eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                eotwJSXFactory('button', {type: "submit", class: "admin-btn admin-btn--confirm"}, ["Continue"]),
                eotwJSXFactory('button', {type: "button", class: "admin-btn admin-btn--cancel js-cancel"}, ["Cancel"])
            ])
        ]);
        this.setContent($content);

        FormValidator.attach($content).on("submit", ($form) => {
            this.emit("submit", $form.serializeJSON())
        });

        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            return false;
        });

    }

}

export default AddContentInputModal;
